import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import withProfile from 'hocs/withProfile';

import Posts from 'api/resources/posts';
import { processErrorByAlert } from 'utils/getErrors';

import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

import ConfirmModal from 'components/ConfirmModal';
import Footer from 'components/ConfirmModal/Footer';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';
import Text from 'components/ConfirmModal/Text';
import ButtonLoader from 'components/Loader/ButtonLoader';

import { ReactComponent as Lock } from 'icons/Lock.svg';

import LockedEmployee from './LockedEmployee';
import LockContainer from './LockContainer';

export class PublicationRowLock extends React.PureComponent {
  state = {
    loading: false,
    isOpen: false,
  }

  handleUnlockClick = () => {
    this.setState({ isOpen: true });
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      await Posts.unlock({
        publicationId: this.props.publicationId,
        force: true,
      });

      Alert.success('Публикация разблокирована');
    } catch (err) {
      processErrorByAlert(err);
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.props.can({
          resource: 'publication',
          permission: 'unlock',
        }) ? (
          <LockContainer as="button" onClick={this.handleUnlockClick} style={{ cursor: 'pointer' }}>
            <Lock /> <LockedEmployee>{this.props.lockedEmployeeFullname}</LockedEmployee>
          </LockContainer>
        ) : (
          <LockContainer>
            <Lock /> <LockedEmployee>{this.props.lockedEmployeeFullname}</LockedEmployee>
          </LockContainer>
        )}

        <ConfirmModal onClose={this.handleClose} isOpen={this.state.isOpen}>
          <form onSubmit={this.handleSubmit}>
            <Content>
              <Title style={{ marginBottom: '16px' }}>Блокировка публикации</Title>

              <Text>
                Выбранная публикация уже редактируется пользователем {this.props.lockedEmployeeFullname}
              </Text>
            </Content>

            <Footer>
              <PrimaryButton type="submit" style={{ marginRight: '16px' }}>
                {this.state.loading ? <ButtonLoader /> : 'Освободить'}
              </PrimaryButton>

              <SecondaryButton type="button" onClick={this.handleClose}>
                Закрыть
              </SecondaryButton>
            </Footer>
          </form>
        </ConfirmModal>
      </React.Fragment>
    );
  }
}

PublicationRowLock.propTypes = {
  publicationId: PropTypes.string.isRequired,
  lockedEmployeeFullname: PropTypes.string,
  can: PropTypes.func,
};

PublicationRowLock.defaultProps = {
  lockedEmployeeFullname: '',
  can: () => {},
};

export default withProfile(PublicationRowLock);
